const signIn = (editor) => {

    editor.BlockManager.add('signIn', {
        category: `Built In Templates`,
        label: `Sign In Template`,
        attributes: {},
        content: `
        <div>
            <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
                <div class="container">
                    <a class="navbar-brand" href="#!">Start Wabli</a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li class="nav-item nav-link pointer" href="#">Home</li>
                            <li class="nav-item nav-link pointer" href="#!">About</li>
                            <li class="nav-item nav-link pointer" href="#!">Contact</li>
                            <li class="nav-item nav-link active pointer" aria-current="page" href="#">Blog</li>
                        </ul>
                    </div>
                </div>
            </nav>
            <header class="py-5 bg-light border-bottom mb-4">
                <div class="container">
                    <div class="text-center my-5">
                        <h1 class="fw-bolder">Welcome to Sign In!</h1>
                        <p class="lead mb-0">A Bootstrap 5 starter layout for signing in</p>
                    </div>
                </div>
            </header>
            <div class="container">
                <div class="row">
                    <div class="col-lg-8" dataItems="getAllCards">
                        <div dataitem=true class="card mb-4">
                            <a href="#!"><img dataCardImage=true class="card-img-top" src="https://icon-library.com/images/github-icon-png/github-icon-png-26.jpg" alt="github icon" /></a>
                            <div class="card-body">

                                <a dataCardButton=true class="btn btn-primary" signInButton='true' href="#!">Sign In</a>
                            </div>
                        </div>
                        
                    </div>      
                </div>
            </div>
            <footer class="py-5 bg-dark">
                <div class="container"><p class="m-0 text-center text-white">Copyright &copy; Your Website 2021</p></div>
            </footer>
        </div>
        `
    })
}

export default signIn;